/* SET STATE */
export const SET_STATE_TYPESREGULATION = "SET_STATE_TYPESREGULATION"

/* TYPESREGULATIONS */
export const GET_TYPESREGULATIONS = "GET_TYPESREGULATIONS"
export const GET_TYPESREGULATIONS_SUCCESS = "GET_TYPESREGULATIONS_SUCCESS"
export const GET_TYPESREGULATIONS_FAIL = "GET_TYPESREGULATIONS_FAIL"

/* TYPESREGULATION */
export const GET_TYPESREGULATION = "GET_TYPESREGULATION"
export const GET_TYPESREGULATION_SUCCESS = "GET_TYPESREGULATION_SUCCESS"
export const GET_TYPESREGULATION_FAIL = "GET_TYPESREGULATION_FAIL"

/**
 * ADD TYPESREGULATION
 */
 export const ADD_NEW_TYPESREGULATION = "ADD_NEW_TYPESREGULATION"
 export const ADD_TYPESREGULATION_SUCCESS = "ADD_TYPESREGULATION_SUCCESS"
 export const ADD_TYPESREGULATION_FAIL = "ADD_TYPESREGULATION_FAIL"

 /**
 * UPDATE TYPESREGULATION
 */
export const UPDATE_TYPESREGULATION = "UPDATE_TYPESREGULATION"
export const UPDATE_TYPESREGULATION_STATUS = "UPDATE_TYPESREGULATION_STATUS"
export const UPDATE_TYPESREGULATION_SUCCESS = "UPDATE_TYPESREGULATION_SUCCESS"
export const UPDATE_TYPESREGULATION_FAIL = "UPDATE_TYPESREGULATION_FAIL"

/**
 * DELETE TYPESREGULATION
 */
export const DELETE_TYPESREGULATION = "DELETE_TYPESREGULATION"
export const DELETE_TYPESREGULATION_SUCCESS = "DELETE_TYPESREGULATION_SUCCESS"
export const DELETE_TYPESREGULATION_FAIL = "DELETE_TYPESREGULATION_FAIL"
